import { SelectInputOption } from 'lib/components/Form/SelectInput/SelectInput'

export const feedbackOptions: SelectInputOption[] = [
  'Online article',
  'Streaming TV (i.e Hulu, Peacock etc.)',
  'Broadcast/Cable TV (i.e CBS, Golf Channel)',
  'Friend',
  'Email',
  'Billboard/Outdoor sign',
  'Facebook/Instagram Ad',
  'Mailer/Pamphlet',
  'Influencer',
  'Podcast',
  'YouTube',
  'Other',
].map((value) => ({
  value,
  label: value,
}))
